import React, { Fragment } from 'react'
import SiteHeader from '../../../components/SiteHeader';
import Breadcumb from '../../../components/Breadcumb'
import FooterArea from '../../../components/FooterArea'
import BlogPost from '../../../components/BlogPost'
import Seo from '../../../components/Seo'
import { breadcrumbSchema } from '../../../seo/config'
// images
import breadcumb from '../../../images/breadcumb/blog.jpeg'
import './style.scss'

const breadcumbMenu = [
    { name: 'Home', route: '/' },
    { name: 'Legal Insights' }
]

const BlogFullWidth = () => {
    return (
        <Fragment>
            <Seo
                title="Legal Insights & News — Indian Law Blog"
                description="Expert legal insights, updates on Indian law and practical advice from Legal Corridor's advocates. Read our latest articles on civil, criminal, family and property law."
                path="/blogs"
                schema={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Legal Insights', path: '/blogs' }])]}
            />
            <SiteHeader />
            <main>
            <Breadcumb
                className="breadcumbArea"
                title="Legal Insights & News"
                breadcumbMenu={breadcumbMenu}
                background={breadcumb}
            />

            <section className="blogListing">
                <div className="container">
                    <BlogPost />
                </div>
            </section>
            </main>
            <FooterArea />
        </Fragment>
    )
}
export default BlogFullWidth